export default {
  hero: {
    cyclingWords: [
      'behavior',
      'language',
      'accessibility',
      'inclusion',
      'perception',
      'attention',
      'memory',
      'curiosity',
      'learning',
      'connection',
      'adaptation',
      'clarity',
      'understanding',
      'belonging',
      'trust',
      'wonder',
      'possibilities',
      'feeling',
    ],
    label: 'Product Design Engineer',
    status: 'Available for the right things',
    headline: {
      line1: 'I build',
      em: 'things',
      line3: 'for humans.',
    },
    desc: "Hi, I'm <strong>Juan Lias</strong> a multidisciplinary maker based in Curitiba, Brazil. I combine design empathy with engineering precision to create digital experiences that feel human from the very first click.",
    description: "Hi, I'm a multidisciplinary  maker <br /> based in Curitiba, PR-Brazil",
    title: {
      first: 'Crafting',
      highlight: 'digital',
      last: 'experiences.',
    },
    scroll: 'Scroll',
    photoAlt: 'Juan Lias — Product Design Engineer',
    ariaSection: 'Hero — Juan Lias portfolio',
  },
  about: {
    watermark: 'Who am I',
    title: 'who am I',
    seeMore: {
      label: 'Discover More',
      title: 'Get to know me',
    },
    story:
      "I grew up in the Caribbean, in a <span class='story-highlight'>Venezuela</span> that shaped me with toughness, good days, hard days, and a creativity born from urgency. There I learned to solve with little and to see order where others saw chaos. In 2019 I migrated to <span class='story-highlight'>Brazil</span> looking for stability and a brighter future. That leap forced me to start from scratch, reinvent myself, and prove that I could level up even on new ground.",
    heroCard: {
      role: 'Creative Developer & Interface Designer',
      bio: 'Passionate about creating digital experiences that truly connect with people. I combine the logic of code with the empathy of design to build useful solutions, focusing on removing friction to achieve interfaces that feel familiar and natural from the very first instant.',
      showMore: 'Show more',
      showLess: 'Show less',
    },
    locationCard: {
      label: 'Based in',
      country: 'Brazil',
    },
    availabilityCard: {
      status: 'Available',
      message: 'for the right things',
    },
    quoteCard: {
      philosophy: '— My philosophy',
      segments: [
        { text: "I don't look for perfe", type: 'type' },
        { text: 'tion', type: 'type', isTypo: true },
        { text: '', type: 'pause', duration: 600 },
        { text: 'tion', type: 'delete' },
        { text: 'ction,', type: 'type' },
        { text: '', type: 'pause', duration: 800 },
        { text: ' I just try to be extraordinary.', type: 'type' },
      ],
    },
    experienceCard: {
      label: 'Years of<br />Experience',
    },
    neurodivergentCard: {
      teaser: "My brain is wired <span class='teaser__highlight'>differently</span>.",
      teaserSub: 'Autism L1 · High Potential',
      button: 'View cognitive profile',
      label: 'Neurodivergent',
      sublabel: 'Cognitive Profile',
      hide: 'Close',
      traits: [
        { id: 'hyperfocus', name: 'Hyperfocus' },
        { id: 'patterns', name: 'Pattern Recognition' },
        { id: 'precision', name: 'Precision' },
        { id: 'systems', name: 'Systems Thinking' },
        { id: 'lateral', name: 'Lateral Thinking' },
        { id: 'curiosity', name: 'Deep Curiosity' },
      ],
      footer: "Different wiring. <span class='footer-highlight'>Extraordinary output.</span>",
    },
    hobbiesCard: {
      title: 'Beyond the System',
      text: "Faith, science and the drive to improve. A balance between God's design, physics laws and the discipline of breaking my own limits.",
      hobbies: [
        'God',
        'Family',
        'Science',
        'Physics',
        'Astrophysics',
        'Design',
        'Arts',
        'Music',
        'Gaming',
        'Dragon Ball',
      ],
    },
    readingCard: {
      title: 'Currently Reading',
    },
    familyCard: {
      title: "Family first <span class='family-card__hearts'>❤️</span>",
      text: 'My family is my strength when I falter, my joy when I am exhausted, and the reason I never stop. They are my priority, my solid ground, and my daily blessing. I thank God for guiding and sustaining us in every step.',
    },
    momentsCard: {
      title: 'Moments behind the pixels',
      labels: {
        alwaysLearning: 'Always learning 📚',
        dreamTeam: 'Dream Team 💜',
      },
    },
    setupCard: {
      items: {
        dell: { detail: 'Core i7 13th Gen • GEFORCE RTX • 32GB RAM • 1TB SSD' },
        mic: { detail: 'USB Condenser Mic' },
        webcam: { detail: 'Webcam 2k' },
        mouse: { detail: 'Mouse' },
        mousepad: { detail: 'Mousepad' },
        tablet: { detail: 'Tablet' },
        buds1: { detail: 'Wireless Earbuds' },
        buds2: { detail: 'Wireless Earbuds' },
        headphones: { detail: 'Over-Ear Headphones' },
        keyboard: { detail: 'Keyboard' },
        bible: { detail: 'Spiritual Guidance' },
        book: { detail: 'UX Book by Don Norman' },
        speaker: { detail: 'Smart Speaker' },
        monitor1: { detail: 'Full HD • IPS' },
        timer: { detail: 'Pomodoro Timer' },
        monitor2: { detail: 'Full HD • IPS' },
        controller: { detail: 'For gaming breaks 🎮' },
      },
    },
    languagesCard: {
      title: 'Languages',
      items: [
        { name: 'Spanish', level: 'Native' },
        { name: 'Portuguese', level: 'Fluent' },
        { name: 'English', level: 'Professional Working Proficiency' },
      ],
    },
  },
  whatIDo: {
    title: {
      first: 'What I',
      highlight: 'Do',
    },
    services: {
      uiUx: {
        title: 'UI/UX',
        description:
          'Crafting intuitive, user-centric interfaces that blend aesthetics with seamless functionality',
      },
      frontend: {
        title: 'ENGINEER',
        description:
          'Engineering scalable, high-performance web applications using modern architecture',
      },
      creative: {
        title: 'CREATIVE',
        description: 'Designing and coding thoughtful digital interfaces with a human touch.',
      },
      interaction: {
        title: 'INTERACTION',
        description: 'Every click, hover and scroll — obsessively considered.',
      },
      humanity: {
        title: 'HUMANITY',
        description: 'Human purpose, technical execution.',
      },
    },
  },
  worksComingSoon: {
    badge: 'Under Construction',
    title: 'Parsing Ideas<br />Into Reality',
    description:
      "I'm currently curating a selection of my best projects to showcase here. Expect something special soon.",
    loading: {
      initializing: 'Initializing...',
      states: [
        'Improving User Cases...',
        'Designing User Flows...',
        'Optimizing Graphic Assets...',
        'Refining Interactions...',
        'Preparing Documentation...',
        'Compiling Best Projects...',
      ],
    },
  },
  journeyV2: {
    label: 'Career Timeline',
    title: 'Experience',
    connect: 'Connect on LinkedIn',
    items: [
      {
        id: 1,
        company: 'Compliance Soluções',
        role: 'Senior/Specialist UX Development Consultant',
        location: 'Remote - Ribeirão Preto, São Paulo, Brazil',
        period: 'May 2022 - Current',
        description:
          'Leading the UX migration of a legacy tax platform serving 100+ companies. Streamlining workflows for 20k+ monthly invoices through research, prototyping, and close collaboration with Product Owners.',
        startYear: 2022,
        endYear: 2025,
      },
      {
        id: 2,
        company: 'Simplify Tanzania',
        role: 'Art Director',
        location: 'Remote - Dar es Salaam, Tanzania',
        period: 'Jun 2019 - Dec 2022',
        description:
          'Led creative direction from MVP definition to frontend implementation. Designed high-fidelity interfaces for invoice management and established the visual brand identity across digital and social channels.',
        startYear: 2019,
        endYear: 2022,
        roles: [
          {
            title: 'Art Director',
            period: 'Feb 2021 - Oct 2022',
            type: 'Full-time',
          },
          {
            title: 'Senior UI/UX - Product Designer and Front-end Developer',
            period: 'Oct 2020 - Feb 2021',
            type: 'Contract',
          },
        ],
      },
      {
        id: 3,
        company: 'Katavi Gaming Limited',
        role: 'Senior UI/UX Product Designer Consultant',
        location: 'Remote - Dar es Salaam, Tanzania',
        period: 'Oct 2017 - May 2022',
        description:
          'Headed the UI/UX department for betting platforms, optimizing for device accessibility. Managed the full design cycle from research to launch using SCRUM, while defining corporate identity and marketing assets.',
        startYear: 2017,
        endYear: 2022,
        roles: [
          {
            title: 'Senior UI/UX Product Designer Consultant',
            period: 'Dec 2020 - May 2022',
            type: 'Freelance',
          },
          {
            title: 'UI/UX - Product Designer and Front-end Developer',
            period: 'Apr 2018 - Dec 2020',
            type: 'Full-time',
          },
          {
            title: 'Junior Front-end Developer and UI/UX Designer',
            period: 'Oct 2017 - Apr 2018',
            type: 'Full-time',
          },
        ],
      },
      {
        id: 4,
        company: 'Freelancer',
        role: 'Product Designer & Developer',
        location: 'Global',
        period: 'Jan 2016 -',
        description:
          'Providing versatile design and development solutions for global clients. Projects range from creating corporate identities and packaging for educational brands to designing interfaces for emerging gaming platforms.',
        startYear: 2016,
        endYear: 2025,
      },
    ],
  },
  testimonials: {
    title: 'Collaborative impact',
    subtitle:
      "I've had the pleasure of collaborating with some amazing people. Here's what they have to say.",
    items: [
      {
        id: 1,
        initials: 'J. A.',
        name: 'Jesus A. A. Rojas',
        role: 'Wharehouse Chief in Traslogistic de Venezuela',
        company: 'TBET',
        quote:
          "Juan has an incredible creativity power, he's a fast learner and self-taught person. He's got the ability to catch the project vision and use his skills to improve it or to add value.",
        linkedin: 'https://www.linkedin.com/in/jesus-armando-acosta-rojas/',
      },
      {
        id: 2,
        initials: 'B. C.',
        name: 'Baraka S. Cassian',
        role: 'Founder & Managing Director, Simplitech Ltd (Simplify)',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Working with Juan on Simplify’s product and frontend experience has been a pleasure. He quickly understood our product, our users, and the constraints we operate in, then translated loose ideas into clean, intuitive interfaces. I appreciated how he communicated clearly, iterated fast on feedback, and paid attention to the small details that make a product feel polished. Juan brings a rare mix of design craft, reliability, and genuine care for the outcome of the project. He is overall a friendly and great person to work with!',
        linkedin: 'https://www.linkedin.com/in/bcassian/',
      },
      {
        id: 3,
        initials: 'C. Z.',
        name: 'Carlos Zerpa',
        role: 'Senior Software Engineer',
        company: 'SIMPLIFY',
        quote:
          'Working alongside Juan Lias on the Simplify VFD project was a testament to his exceptional talent. His leadership in product design, coupled with his expertise in Vue.js, resulted in a polished, intuitive application. His professionalism, attention to detail, and collaborative spirit make him a standout designer and developer.',
        linkedin: 'https://www.linkedin.com/in/carlos-javier-zerpa/',
      },
      {
        id: 4,
        initials: 'M. V.',
        name: 'Mariana Vielma',
        role: 'Product Owner',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Juan is an extraordinary professional with incredible talent and a great sense of humor, making collaboration both productive and enjoyable. His designs always carry his signature "extra spark" that unique touch that elevates every project and leaves you wanting to see more of his work. He consistently gives 100% in everything he does, bringing creativity, attention to detail, and strong vision that add real value to any product or team.',
        linkedin: 'https://www.linkedin.com/in/mariana-vielma-67585a237/',
      },
      {
        id: 5,
        initials: 'C. S.',
        name: 'Cezar Sakugawa',
        role: 'Product Manager',
        company: 'Compliance Soluções Fiscais',
        quote:
          'I had the privilege of leading Juan and I can say he stands out where few manage to balance: strategic product vision with refined design execution. His attention to detail goes beyond aesthetics — he thinks about the user experience end to end. His clear communication and collaborative attitude make him someone who elevates the level of any team lucky enough to have him.',
        linkedin: 'https://www.linkedin.com/in/cezarsakugawa/',
      },
      {
        id: 6,
        initials: 'V. S.',
        name: 'Vinícius Santos',
        role: 'Product Owner',
        company: 'Compliance Soluções Fiscais',
        quote:
          "At the company where I worked with Juan, we were in constant contact from start to finish, making collaboration always active and effective. I admit that, being a Product Owner, it's complex to give attention to all stakeholders, but Juan never hid away and always showed initiative in reaching out to me, whether to ask a question or even to present a high-fidelity prototype of a new increment. He was never afraid to show his ideas and work hard on them to turn them into reality, always seeking feedback to improve more and more and deliver value to the user. His drive to make things happen is, without a doubt, his strongest asset.",
        linkedin: 'https://www.linkedin.com/in/vinícius-santos',
      },
    ],
  },
  works: {
    section: {
      built: "What I've built",
      building: "What I'm building",
      otherLine1: '& other things',
      otherLine2: 'I built and helped build',
      closing: 'Still learning. Still building.',
    },
    ui: {
      caseStudy: 'Case Study',
      comingSoon: 'Coming soon',
      visitProject: 'Visit Project',
    },
    projects: {
      'ultra-instinct': {
        category: 'VS Code Extension',
        description:
          'A neurodivergent-designed VS Code theme trilogy built to eliminate visual noise and achieve deep focus and flow state.',
      },
      braillihub: {
        category: 'Accessibility Tool',
        description:
          'A space to explore the languages that connect people, beyond words. Translate text to Braille, Morse Code, or Caesar Cipher — and explore each with interactive tools designed for curiosity.',
      },
      milo: {
        category: 'Brand Character',
        description:
          "Milo is Braillihub's brand character — a curious little explorer who believes every language deserves to be understood. He's here to embody the spirit of discovery and keep you company while you explore Braille, Morse, and beyond.",
      },
      firmamesh: {
        category: 'Atmospheric Gradients',
        description:
          'Explore 141 real atmospheric landscapes from 75 countries, with 5 moments of the day using OKLCH for vivid color transitions. The slider traverses the full solar arc — from nadir to zenith — with real-time sun, moon, and stars, plus astronomically calculated lunar phase. Copy gradients as CSS, export SVG for Figma, or download high-res images. Includes an atmospheric layer editor with fine control over lightness, chroma, and hue.',
      },
      hyperdrive: {
        category: 'Web Portfolio',
        description:
          'A stunning portfolio website with a hyperspace travel animation built with Vue 3 and featuring smooth GSAP transitions.',
      },
    },
    inProgress: {
      hogarflow: {
        category: 'Home Command Center',
        description:
          'HogarFlow is a smart home platform that centralizes finances, shopping, tasks, and routines in one place — designed so users stop managing and start living, with Shury as the AI assistant that handles it all.',
      },
      shury: {
        category: 'AI HogarFlow Assistant',
        description:
          "Shury is HogarFlow's AI assistant — she handles finances, tasks, notes, subscriptions, and takes care of home errands on behalf of the user, so they can live with calm and control.",
      },
    },
    otherProjects: {
      tbet: {
        role: 'Product Designer · UI/UX Lead & Frontend Engineer',
        description:
          'Led the UI/UX department at Katavi Gaming Limited (Tanzania) — user research, design system, wireframes, and accessibility-focused UI for users with older devices. I also owned the frontend implementation. Followed the full product development cycle under SCRUM/Jira, and collaborated with marketing on corporate identity and social media visuals.',
      },
      cassian: {
        role: 'Brand Identity, UI/UX Design & Full-Stack Dev',
        description:
          'Full rebrand and website refresh for a certified public accounting & tax consultancy firm in Tanzania (Dar es Salaam & Arusha) — visual identity overhaul, complete site redesign, from concept to deployment.',
      },
      'simplify-vfd': {
        role: 'Art Director · Product Designer & Frontend Engineer',
        description:
          'At Simplitech Limited (Tanzania), I led product design end-to-end — competitor research, brand identity, MVP scoping, and high-fidelity interfaces. I also owned the entire frontend and all API integrations, and co-designed the marketing visual system.',
      },
    },
  },
}
